import { FC, useEffect, useTransition } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
  INotificationDto,
  notificationEventsSelector,
  notificationsCountAtom,
  tableRowsAtomFamily,
  useNotificationsApi,
} from "@ryde/shared";

export const BellNotificationsProvider: FC = () => {
  const setNotificationsTableDtos = useSetRecoilState(
    tableRowsAtomFamily("notification"),
  );
  const setNotificationsCount = useSetRecoilState(notificationsCountAtom);
  const notificationsEvent = useRecoilValue(notificationEventsSelector);
  const { fetchCount } = useNotificationsApi();
  const [, startTransition] = useTransition();

  useEffect(() => {
    // init load notifications
    startTransition(() => {
      fetchCount();
    });
  }, [fetchCount]);

  useEffect(() => {
    //TODO implement increment for isRead=false and priority=Alert
    // setNotificationsCount();
    setNotificationsTableDtos(currVal => {
      const newNotification = notificationsEvent.map(
        ({ data }) => data as INotificationDto,
      );
      const newNotificationIds = newNotification.map(({ id }) => id);
      const newNotificationIdsSet = new Set(newNotificationIds);

      return [
        ...(currVal ?? []).filter(({ id }) => !newNotificationIdsSet.has(id)),
        ...newNotification,
      ];
    });
  }, [notificationsEvent, setNotificationsCount, setNotificationsTableDtos]);

  return null;
};
